import React, { Component, ElementType /* ErrorInfo */ } from "react";

export interface IErrorProps {
  error: undefined | Error;
  onClear: () => void;
}

export type Props = {
  onError: ElementType<IErrorProps>;
};

interface IState {
  error: Error | undefined;
  hasError: boolean;
}

const ErrorBoundary = (props: any) => {
  //class ErrorBoundary extends Component<Props, IState> {

  const [error, setError] = React.useState(undefined as any);
  const [hasError, setHasError] = React.useState(false);

  //todo fix this , so it will catch errors
  const componentDidCatch = (error: Error /*  info: ErrorInfo */) => {
    setError(error);
    setHasError(true);
  };

  const ErrorView = props.onError;
  if (hasError) {
    return (
      <ErrorView
        error={error}
        onClear={() => {
          setError(undefined);
          setHasError(false);
        }}
      />
    );
  }
  return props.children;
};
export default ErrorBoundary;
